import React from "react";
import { useFormikContext, FieldArray } from "formik";
import get from "lodash/get";
import classnames from "classnames";
import DebounceTextarea from "components/DebounceTextarea";
import HoverIconButton from "components/HoverIconButton";
import Callout from "components/Callout";
import cloneDeep from "lodash/cloneDeep";

const MetadataList = ({ name }) => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();
  const metadata = get(values, name);

  if (metadata && metadata.length) {
    return (
      <FieldArray
        name={name}
        render={() => {
          const nodes = metadata.map((metadataField, keyIx) => {
            const { uuid, key, value } = metadataField;
            const metadataFieldKey = `${name}[${keyIx}]`;
            const metadataFieldKeyPath = `${metadataFieldKey}.key`;
            const metadataFieldValuePath = `${metadataFieldKey}.value`;

            const fieldTouched = get(touched, metadataFieldKey);

            return (
              <li
                key={uuid}
                className={classnames(
                  "flex flex-column flex-row-ns w-100 pb3 pb0-ns bb bn-ns hairline-1",
                  {
                    "pt3 pt2-ns": keyIx
                  }
                )}
              >
                <div className="w-30-ns w-100 pb3 pb0-ns">
                  <DebounceTextarea
                    inputValue={key}
                    placeholder="Key"
                    debounce={500}
                    name={metadataFieldKeyPath}
                    valueSet={(val) => {
                      setFieldValue(metadataFieldKeyPath, val);

                      if (!fieldTouched) {
                        setFieldTouched(metadataFieldKey, true);
                      }
                    }}
                  />
                </div>
                <div className="flex flex-row w-70-ns w-100 ph2-ns">
                  <DebounceTextarea
                    inputValue={value}
                    placeholder="Value"
                    debounce={500}
                    name={metadataFieldValuePath}
                    valueSet={(val) => {
                      setFieldValue(metadataFieldValuePath, val);
                      if (!fieldTouched) {
                        setFieldTouched(metadataFieldKey, true);
                      }
                    }}
                  />
                </div>
                <div className="w-100 w-auto-ns flex justify-end pt2 pt0-ns">
                  <HoverIconButton
                    type="delete"
                    tooltip="Delete"
                    onClick={() => {
                      if (!fieldTouched) {
                        setFieldTouched(metadataFieldKey, true);
                      }
                      /**
                       * Note: arrayHelpers.remove was resetting the touched value and preventing form submission
                       */
                      const clonedMetadata = cloneDeep(metadata);

                      clonedMetadata.splice(keyIx, 1);
                      setFieldValue(name, clonedMetadata);
                    }}
                  />
                </div>
              </li>
            );
          });

          return <ul className="list ma0 pa0">{nodes}</ul>;
        }}
      />
    );
  } else {
    return <Callout copy="No metadata." />;
  }
};

export default MetadataList;
